import { ArrowLeft } from "lucide-react";
import { Button } from "./button";
import { useNavigate } from "react-router";
interface HeaderProps {
  title?: string;
  showBackButton?: boolean;
  rightElement?: React.ReactNode;
  onBackClick?: () => void;
  className?: string;
}
export const Header = ({ 
  title, 
  showBackButton = false, 
  rightElement,
  onBackClick,
  className = ""
}: HeaderProps) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };
  return (
    <div className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100 ${className}`}>
      <div className="flex items-center justify-between px-5 py-4">
        <div className="flex items-center gap-4">
          {showBackButton && (
            <Button
              size="sm"
              className="w-10 h-10 rounded-full bg-primary text-white p-0"
              onClick={handleBackClick}
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
          )}
          
          {title && (
            <h1 className="text-xl font-bold text-black">{title}</h1>
          )}
        </div>
        
        {rightElement && (
          <div className="flex items-center">
            {rightElement}
          </div>
        )}
      </div>
    </div>
  );
};